var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8504 8.64564L8.70825 6.69856C8.61157 6.61068 8.4805 6.56186 8.34299 6.56186H7.99277C8.58578 5.87247 8.93815 5.00537 8.93815 4.0621C8.93815 1.81818 6.93781 0 4.46908 0C2.00034 0 0 1.81818 0 4.0621C0 6.30602 2.00034 8.12421 4.46908 8.12421C5.50685 8.12421 6.46082 7.80393 7.21928 7.26492V7.58324C7.21928 7.70823 7.27299 7.82736 7.36968 7.91524L9.51183 9.86232C9.7138 10.0459 10.0404 10.0459 10.2402 9.86232L10.8483 9.30964C11.0502 9.12606 11.0502 8.82922 10.8504 8.64564ZM4.46908 6.56186C2.95002 6.56186 1.71888 5.44478 1.71888 4.0621C1.71888 2.68138 2.94787 1.56235 4.46908 1.56235C5.98813 1.56235 7.21928 2.67943 7.21928 4.0621C7.21928 5.44283 5.99028 6.56186 4.46908 6.56186Z",
    fill: "#FF3F78"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.faea7686ee8f4ee4e788a4300c461f15.svg";
export { ForwardRef as ReactComponent };